import '.ac{position:relative;}.ssr-plugin'
import '.jt{width:64px;}.ssr-plugin'
import '.ju{height:64px;}.ssr-plugin'
import '.aq{flex-shrink:0;}.ssr-plugin'
import '.bl{position:absolute;}.ssr-plugin'
import '.jv{bottom:-4px;}.ssr-plugin'
import '.hn{right:-4px;}.ssr-plugin'
import '.g2{border-radius:50%;}.ssr-plugin'
import '.cg{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.jw{width:32px;}.ssr-plugin'
import '.jx{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ac jt ju aq"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bl jv hn g2 cg b5 jw jx"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
